export const Error = () => (
  <svg fill="none" height="264" viewBox="0 0 324 264" width="324" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M212.969 17.658C221.553 17.657 229.944 20.2253 237.081 25.0381C244.219 29.851 249.782 36.6921 253.067 44.6964C256.352 52.7007 257.212 61.5085 255.538 70.0061C253.863 78.5036 249.73 86.3092 243.661 92.4355C237.591 98.5619 229.858 102.734 221.439 104.424C213.021 106.114 204.295 105.246 196.365 101.93C188.435 98.614 181.657 92.9987 176.889 85.7945C172.121 78.5902 169.576 70.1205 169.577 61.4566C169.578 49.8407 174.15 38.7009 182.287 30.4873C190.425 22.2737 201.461 17.6589 212.969 17.658ZM249.348 61.4617C249.351 54.1965 247.218 47.0939 243.221 41.0519C239.224 35.01 233.542 30.3001 226.893 27.518C220.244 24.7359 212.927 24.0065 205.867 25.422C198.807 26.8376 192.322 30.3345 187.231 35.4705C182.141 40.6066 178.673 47.151 177.267 54.2763C175.862 61.4015 176.581 68.7875 179.334 75.5001C182.087 82.2127 186.751 87.9505 192.735 91.9878C198.719 96.025 205.755 98.1805 212.952 98.1815H212.963C217.742 98.1837 222.475 97.2354 226.89 95.3907C231.306 93.5461 235.319 90.8412 238.699 87.4307C242.079 84.0202 244.76 79.9709 246.589 75.5141C248.418 71.0574 249.359 66.2805 249.358 61.4566L249.348 61.4617Z"
      fill="#2ED3AE"
    />
    <path d="M213.702 62.7524L213.48 62.902C213.557 62.8567 213.631 62.8067 213.702 62.7524Z" fill="#1072BA" />
    <path
      d="M213.176 63.0221C213.271 62.9932 213.364 62.9578 213.454 62.916C213.365 62.9598 213.272 62.9953 213.176 63.0221Z"
      fill="#1072BA"
    />
    <path
      d="M211.182 61.5232C211.174 61.6012 211.174 61.6798 211.182 61.7578C211.176 61.6797 211.176 61.6012 211.182 61.5232Z"
      fill="#1072BA"
    />
    <path
      d="M213.833 62.6304L213.702 62.7544C213.63 62.8077 213.556 62.857 213.48 62.9024H213.454C213.364 62.9445 213.271 62.9803 213.176 63.0095C213.128 63.0263 213.079 63.0383 213.028 63.0451H212.969C212.892 63.0519 212.814 63.0519 212.737 63.0451C212.656 63.052 212.575 63.052 212.494 63.0451H212.444C212.394 63.0385 212.345 63.0265 212.297 63.0095C212.048 62.937 211.821 62.8012 211.639 62.615C211.527 62.5019 211.431 62.3731 211.356 62.2326C211.313 62.1419 211.278 62.0481 211.25 61.9521C211.233 61.9041 211.221 61.8546 211.214 61.8042C211.213 61.7838 211.213 61.7633 211.214 61.743C211.206 61.665 211.206 61.5863 211.214 61.5084C211.214 61.3025 211.254 61.0986 211.332 60.9085C211.41 60.7183 211.525 60.5455 211.669 60.4L214.317 57.7174V61.5084C214.317 61.7189 214.274 61.9272 214.191 62.1202C214.108 62.3133 213.986 62.487 213.833 62.6304Z"
      fill="#1072BA"
    />
    <path
      d="M214.288 33.6513V57.0993C213.262 56.792 212.162 56.8625 211.182 57.2982V33.6513C211.182 33.2356 211.346 32.8369 211.637 32.543C211.928 32.2491 212.323 32.0839 212.735 32.0839C212.939 32.0837 213.141 32.1241 213.33 32.2028C213.518 32.2815 213.69 32.3969 213.834 32.5425C213.978 32.6881 214.092 32.861 214.17 33.0512C214.248 33.2415 214.288 33.4454 214.288 33.6513Z"
      fill="#1072BA"
    />
    <path
      d="M214.288 57.0994V57.7386L211.637 60.4143C211.493 60.5598 211.378 60.7326 211.3 60.9228C211.222 61.113 211.182 61.3169 211.182 61.5227V57.2983C212.162 56.8626 213.262 56.7921 214.288 57.0994Z"
      fill="#1072BA"
    />
    <path
      d="M225.919 50.4358L217.03 59.4168C216.547 58.4551 215.743 57.6969 214.76 57.2766L223.718 48.2292C223.859 48.0705 224.03 47.9423 224.221 47.8526C224.413 47.7628 224.62 47.7133 224.831 47.7071C225.042 47.701 225.252 47.7382 225.448 47.8166C225.645 47.895 225.823 48.0129 225.973 48.1631C226.122 48.3133 226.24 48.4927 226.319 48.6904C226.397 48.888 226.435 49.0998 226.43 49.3127C226.425 49.5257 226.377 49.7354 226.29 49.9291C226.202 50.1227 226.076 50.2963 225.919 50.4392V50.4358Z"
      fill="#1072BA"
    />
    <path
      d="M214.76 57.2679C215.743 57.6882 216.547 58.4464 217.03 59.4082L213.83 62.6382C213.975 62.4941 214.091 62.3218 214.169 62.1316C214.247 61.9414 214.286 61.7373 214.285 61.5315V57.7388L214.751 57.2679H214.76Z"
      fill="#1072BA"
    />
    <path
      d="M217.517 61.4578C217.518 62.2787 217.299 63.0846 216.883 63.7904C216.468 64.4962 215.871 65.0755 215.157 65.4673C214.442 65.859 213.636 66.0485 212.823 66.0158C212.01 65.983 211.222 65.7293 210.54 65.2813C209.858 64.8334 209.309 64.2078 208.951 63.4709C208.593 62.734 208.438 61.913 208.504 61.0948C208.57 60.2765 208.853 59.4914 209.325 58.8225C209.796 58.1536 210.438 57.6256 211.182 57.2945V61.519C211.176 61.597 211.176 61.6755 211.182 61.7536C211.181 61.7739 211.181 61.7944 211.182 61.8148C211.189 61.8651 211.201 61.9147 211.218 61.9627C211.246 62.0587 211.281 62.1525 211.324 62.2432C211.399 62.3837 211.495 62.5125 211.607 62.6257C211.789 62.8118 212.016 62.9476 212.265 63.0201C212.313 63.0371 212.362 63.0491 212.412 63.0558H212.462C212.543 63.0626 212.624 63.0626 212.705 63.0558C212.782 63.0625 212.86 63.0625 212.937 63.0558H212.998C213.048 63.0489 213.098 63.0369 213.146 63.0201C213.242 62.993 213.335 62.9571 213.424 62.913H213.449L213.672 62.7651L213.811 62.6478L217.011 59.4178C217.336 60.0484 217.509 60.7472 217.517 61.4578Z"
      fill="#CFE3F1"
    />
    <path
      d="M94.064 140.55C94.7989 139.805 95.6725 139.215 96.6345 138.812C97.5964 138.41 98.6278 138.204 99.6691 138.206C101.647 138.245 103.546 138.99 105.032 140.309L105.279 140.55C106.016 141.293 106.601 142.176 107 143.148C107.398 144.119 107.603 145.161 107.602 146.213C107.601 147.137 107.444 148.054 107.137 148.924C106.22 148.086 105.256 147.304 104.248 146.58C103.869 146.312 103.425 146.154 102.963 146.123C102.501 146.093 102.04 146.191 101.63 146.407C101.219 146.623 100.876 146.949 100.636 147.349C100.397 147.749 100.271 148.207 100.272 148.674H99.3525C99.3559 148.083 99.1554 147.508 98.7853 147.049C98.4152 146.59 97.8985 146.276 97.3238 146.159C96.749 146.043 96.152 146.131 95.6351 146.41C95.1181 146.689 94.7133 147.141 94.4901 147.688C94.4548 147.77 94.283 148.198 94.0304 148.858L93.6413 148.674V142.918H92.4421C92.8351 142.035 93.3848 141.233 94.064 140.55Z"
      fill="#1072BA"
    />
    <path
      d="M107.154 148.925C106.562 150.579 105.447 151.99 103.981 152.939C103.158 152.159 102.286 151.434 101.37 150.768C100.812 150.392 100.424 149.807 100.293 149.143C100.161 148.479 100.297 147.789 100.669 147.225C101.042 146.662 101.621 146.27 102.279 146.138C102.938 146.005 103.621 146.142 104.179 146.518L104.265 146.578C105.273 147.302 106.237 148.086 107.154 148.925Z"
      fill="#1072BA"
    />
    <path
      d="M114.17 165.362C114.683 166.086 115.02 166.921 115.155 167.801C115.291 168.68 115.22 169.579 114.948 170.426C114.676 171.264 114.182 172.01 113.52 172.585C112.855 173.16 112.044 173.535 111.179 173.668L110.931 173.709C110.379 173.806 109.848 173.959 109.175 174.139L109.453 173.694C111.321 171.006 112.812 168.072 113.886 164.973L114.17 165.362Z"
      fill="#CFE3F1"
    />
    <path
      d="M107.507 156.001L113.892 164.973C112.819 168.072 111.327 171.007 109.459 173.694L109.181 174.14C107.485 174.591 105.761 174.932 104.021 175.16C103.574 175.226 103.12 175.226 102.674 175.16C103.468 173.73 104.311 172.329 105.2 170.957C107.184 167.792 109.242 164.523 109.308 161.966C109.188 159.895 108.397 157.921 107.058 156.348L107.507 156.001Z"
      fill="#1072BA"
    />
    <path
      d="M181.274 184.026C181.304 191.748 168.737 199.857 168.737 199.857L168.343 199.913C168.138 198.485 167.893 197.063 167.608 195.649C171.125 193.208 177.399 188.606 177.914 183.904C178.263 180.744 177.944 178.598 175.43 177.673C178.076 177.357 181.252 178.154 181.274 184.026Z"
      fill="#CFE3F1"
    />
    <path
      d="M308.659 184.516C309.859 189.97 309.293 192.764 307.253 193.912C306.393 194.125 305.508 194.219 304.622 194.189V193.886C307.624 182.255 299.615 183.547 297.54 181.121C295.465 178.695 296.437 173.741 295.519 171.214C294.601 168.686 291.861 168.385 290.414 167.579C288.082 166.277 286.953 163.018 286.908 158.663C286.908 156.652 286.443 154.583 285.153 153.836C281.757 151.881 280.058 158.066 279.992 158.306C279.272 156.806 278.398 155.385 277.387 154.068C277.303 153.665 277.197 153.268 277.069 152.878L277.387 152.77C278.034 150.651 279.745 147.419 282.34 146.407C282.665 146.286 283.005 146.214 283.351 146.193C286.012 146.023 289.751 148.517 290.435 154.062C291.233 160.352 292.456 162.268 293.939 162.977C295.423 163.686 298.15 164.091 299.044 166.613C299.939 169.136 298.943 174.093 301.065 176.519C303.187 178.945 307.453 179.057 308.659 184.516Z"
      fill="#2ED3AE"
    />
    <path
      d="M107.507 156.002L107.038 156.342C106.113 155.12 105.083 153.982 103.96 152.942C105.427 151.993 106.542 150.582 107.134 148.928C110.209 151.716 114.524 156.639 114.347 162.144C114.31 163.104 114.157 164.055 113.892 164.978L107.507 156.002Z"
      fill="#1072BA"
    />
    <path
      d="M163.041 179.138C162.779 178.335 162.347 177.6 161.774 176.983C161.202 176.367 160.503 175.884 159.726 175.568C162.383 173.886 165.306 172.679 168.368 171.998C173.138 171.185 182.716 170.905 184.557 179.029C181.572 172.029 174.074 173.785 171.908 174.541C168.866 175.947 165.97 177.656 163.263 179.641H163.137C163.117 179.471 163.085 179.303 163.041 179.138Z"
      fill="white"
    />
    <path
      d="M283.324 146.208C282.978 146.229 282.638 146.301 282.313 146.422C279.713 147.442 278.007 150.672 277.36 152.785L277.042 152.892C276.678 151.765 276.029 150.753 275.157 149.958C274.285 149.163 273.222 148.612 272.073 148.362C271.413 148.174 270.736 148.049 270.052 147.99C270.307 147.018 270.857 146.151 271.625 145.511C272.393 144.87 273.34 144.489 274.334 144.42C277.416 144.43 280.468 145.037 283.324 146.208Z"
      fill="#CFE3F1"
    />
    <path
      d="M80.6543 118.917C81.6887 118.917 82.713 119.123 83.6686 119.523C84.6242 119.923 85.4924 120.509 86.2237 121.247C86.955 121.986 87.5351 122.862 87.9307 123.827C88.3264 124.792 88.5299 125.826 88.5297 126.87V127.263C88.2754 132.429 87.9722 138.843 87.8004 142.928H50.9162V138.297L42.4025 126.353C41.9054 125.651 41.6094 124.824 41.5469 123.963C41.4844 123.102 41.6578 122.241 42.0481 121.473C42.4384 120.705 43.0305 120.06 43.7597 119.61C44.4888 119.159 45.3268 118.919 46.1819 118.917H80.6543Z"
      fill="#CFE3F1"
    />
    <path
      d="M105.028 140.309C103.543 138.989 101.643 138.244 99.6656 138.206C99.886 132.709 100.828 127.265 102.468 122.018C102.83 121.099 103.457 120.311 104.267 119.756C105.078 119.202 106.036 118.906 107.016 118.907H110.687C111.544 118.908 112.384 119.147 113.115 119.598C113.847 120.049 114.44 120.695 114.831 121.464C115.223 122.234 115.396 123.097 115.332 123.96C115.269 124.822 114.971 125.651 114.472 126.353L105.028 140.309Z"
      fill="#CFE3F1"
    />
    <path
      d="M248.715 137.139H263.645C263.062 138.889 261.968 140.419 260.506 141.529C259.045 142.639 257.286 143.277 255.459 143.359H242.138C240.311 143.277 238.552 142.639 237.091 141.529C235.63 140.419 234.536 138.888 233.953 137.139H248.715Z"
      fill="#1072BA"
    />
    <path
      d="M104.021 175.176C105.761 174.948 107.485 174.607 109.181 174.156C107.093 177.499 105.033 180.916 105.308 183.551C105.343 183.885 105.313 184.222 105.22 184.543C105.126 184.865 104.971 185.165 104.762 185.425C104.554 185.686 104.296 185.903 104.005 186.063C103.713 186.224 103.393 186.324 103.063 186.36C102.971 186.365 102.88 186.365 102.788 186.36C102.162 186.363 101.556 186.132 101.089 185.71C100.622 185.288 100.327 184.706 100.262 184.077C100.135 180.931 100.968 177.822 102.648 175.17C103.103 175.242 103.566 175.244 104.021 175.176Z"
      fill="#1072BA"
    />
    <path
      d="M32.2383 214.037C32.2383 216.809 52.9811 219.052 78.6147 219.052C89.968 219.052 100.37 218.613 108.425 217.882H108.486C108.141 224.869 108.65 231.872 110.002 238.732L109.648 238.824C105.483 240.354 95.8105 242.665 78.4227 242.665C67.8973 242.692 57.4216 241.208 47.3103 238.256C44.9354 237.536 42.7526 236.283 40.9255 234.591C33.7053 229.602 31.8594 221.773 31.8594 214.431V214.032L32.2383 214.037Z"
      fill="#1072BA"
    />
    <path
      d="M50.9112 148.676C50.1789 148.64 49.4884 148.321 48.9828 147.785C48.4771 147.249 48.1951 146.537 48.1951 145.797C48.1951 145.057 48.4771 144.346 48.9828 143.81C49.4884 143.274 50.1789 142.955 50.9112 142.919V148.676Z"
      fill="#1072BA"
    />
    <path
      d="M159.726 175.58C160.504 175.894 161.204 176.377 161.776 176.994C162.349 177.611 162.781 178.347 163.041 179.15C163.085 179.318 163.117 179.488 163.137 179.66C163.869 185.537 152.301 193.376 136.708 197.435C121.116 201.495 107.27 200.279 105.069 194.8C104.995 194.636 104.936 194.465 104.892 194.29C103.881 190.38 108.701 185.466 116.715 181.381C121.349 179.07 126.213 177.263 131.224 175.988C143.295 172.838 154.339 172.859 159.726 175.58Z"
      fill="#CFE3F1"
    />
    <path
      d="M297.505 181.136C299.605 183.557 307.623 182.265 304.578 193.901V194.199C301.407 194.28 296.297 194.029 294.178 193.1C290.978 191.696 294.436 186.972 294.305 183.399C294.173 179.825 290.722 181.217 288.294 177.908C285.431 174.018 288.673 171.142 286.317 170.05C284.728 169.198 283.382 167.95 282.406 166.424C282.043 163.6 281.208 160.858 279.937 158.315C280.002 158.075 281.702 151.891 285.097 153.846C286.387 154.587 286.832 156.661 286.852 158.672C286.898 163.028 288.031 166.286 290.359 167.589C291.805 168.394 294.569 168.702 295.463 171.223C296.358 173.744 295.4 178.705 297.505 181.136Z"
      fill="#1072BA"
    />
    <path
      d="M163.753 247.8C163.753 247.8 194.254 250.501 179.548 256.888C161.811 264.599 134.163 261.883 127.824 259.646C120.245 256.96 120.043 253.855 120.038 253.696C124.395 256.387 130.288 257.516 138.864 257.383H138.95C152.23 257.599 159.074 254.79 163.753 247.8Z"
      fill="#1072BA"
    />
    <path
      d="M108.747 212.525C108.623 214.309 108.535 216.095 108.484 217.882H108.424C100.365 218.613 89.9528 219.046 78.613 219.046C52.9995 219.046 32.2366 216.804 32.2366 214.031C32.2366 211.259 52.981 209.016 78.6147 209.016C90.1599 209.016 100.211 209.47 108.328 210.227L108.616 210.133C109.08 211.663 109.597 213.193 110.163 214.694C109.792 214.459 109.478 214.142 109.248 213.765C109.017 213.389 108.875 212.964 108.833 212.523L108.747 212.525Z"
      fill="#2ED3AE"
    />
    <path d="M254.655 146.876V147.386H242.948V143.357H254.66L254.655 146.876Z" fill="#2ED3AE" />
    <path
      d="M113.73 247.294C115.317 249.89 117.476 252.081 120.038 253.698C106.748 258.176 64.4353 256.889 48.1692 251.85C44.8938 250.926 42.0215 248.916 40.0143 246.145C42.5945 247.223 55.3995 252.36 78.4379 252.36C90.3918 252.54 102.3 250.83 113.73 247.294Z"
      fill="#1072BA"
    />
    <path
      d="M277.37 154.077H220.233C220.431 152.694 221.043 151.405 221.987 150.384C222.931 149.362 224.162 148.657 225.515 148.362C227.72 147.622 236.826 147.428 242.943 147.388H254.655C259.619 147.423 266.428 147.558 270.054 147.989C270.738 148.049 271.414 148.173 272.075 148.362C273.223 148.612 274.287 149.163 275.158 149.957C276.03 150.752 276.68 151.764 277.043 152.892C277.174 153.281 277.283 153.676 277.37 154.077Z"
      fill="white"
    />
    <path
      d="M87.7921 142.919H92.4422C91.9753 143.954 91.7352 145.077 91.7382 146.214C91.7366 147.049 91.8645 147.88 92.1171 148.676H87.6304C87.6304 147.608 87.6304 146.76 87.6657 146.214C87.6859 145.514 87.7314 144.354 87.7921 142.919Z"
      fill="#1072BA"
    />
    <path
      d="M99.3524 148.674C99.3507 149.012 99.2837 149.346 99.1554 149.659C99.1554 149.699 98.4211 151.452 97.6076 153.939C95.8662 153.466 94.3364 152.409 93.2708 150.94C93.5588 150.109 93.8232 149.41 94.0303 148.858C94.283 148.188 94.4548 147.77 94.4901 147.688C94.7133 147.141 95.1181 146.689 95.635 146.41C96.152 146.131 96.749 146.043 97.3238 146.159C97.8985 146.276 98.4152 146.59 98.7853 147.049C99.1554 147.508 99.3559 148.083 99.3524 148.674Z"
      fill="#1072BA"
    />
    <path
      d="M93.6413 148.674L94.0303 148.858C93.8232 149.403 93.5587 150.109 93.2707 150.94C92.7703 150.251 92.381 149.486 92.1171 148.674H93.6413Z"
      fill="#1072BA"
    />
    <path
      d="M87.6303 168.046C87.6395 170.234 86.7957 172.337 85.2812 173.902C83.7667 175.467 81.703 176.368 79.5359 176.41C78.6197 176.41 77.7557 176.44 77.0366 176.44C66.6098 176.307 56.2071 175.394 45.9141 173.709L45.6901 173.673C44.8231 173.539 44.0102 173.164 43.3429 172.589C42.6755 172.015 42.1801 171.264 41.9124 170.421C41.6406 169.575 41.5698 168.677 41.7059 167.798C41.842 166.92 42.181 166.086 42.6955 165.365L50.9061 153.819V148.678H87.6218C87.5949 153.208 87.6101 161.7 87.6303 168.046Z"
      fill="#CFE3F1"
    />
    <path
      d="M296.134 231.546C296.134 231.546 321.379 237.934 280.491 244.889C240.474 251.689 208.264 241.749 201.469 231.546C201.469 231.546 212.033 241.759 248.796 241.759C290.2 241.749 296.134 231.546 296.134 231.546Z"
      fill="#1072BA"
    />
    <path
      d="M165.54 151.984C168.156 151.433 171.762 150.707 173.456 150.533C173.888 150.484 174.324 150.484 174.756 150.533C176.976 150.809 177.503 152.504 175.996 153.408C174.787 154.124 169.18 153.546 165.584 153.082C165.453 153.067 165.332 153.006 165.242 152.909C165.152 152.812 165.099 152.685 165.094 152.552C165.088 152.42 165.13 152.289 165.212 152.185C165.293 152.08 165.411 152.009 165.54 151.984Z"
      fill="#2ED3AE"
    />
    <path
      d="M167.765 214.532C168.07 213.455 168.333 212.31 168.555 211.11C168.549 211.037 168.561 210.963 168.59 210.896L168.899 210.952C168.899 210.952 170.948 233.156 166.317 243.186C165.587 244.782 164.733 246.317 163.762 247.776C159.083 254.746 152.238 257.574 138.973 257.365H138.888C130.312 257.498 124.419 256.345 120.061 253.678C117.491 252.068 115.323 249.88 113.729 247.284C112.897 245.965 112.154 244.59 111.507 243.169C110.869 241.739 110.369 240.249 110.015 238.722C108.653 231.862 108.144 224.858 108.499 217.871C108.551 216.084 108.638 214.298 108.762 212.514H108.848C108.89 212.955 109.032 213.38 109.263 213.756C109.494 214.133 109.807 214.45 110.179 214.685C113.958 217.688 125.38 219.869 138.879 219.869C152.614 219.884 164.21 217.616 167.765 214.532Z"
      fill="#2ED3AE"
    />
    <path
      d="M107.032 156.344C108.367 157.92 109.157 159.892 109.283 161.962C109.202 164.512 107.159 167.788 105.175 170.953C104.298 172.333 103.455 173.734 102.648 175.156C101.508 174.993 100.463 174.425 99.6992 173.555C98.9355 172.686 98.5034 171.57 98.48 170.408C98.3739 165.036 98.2779 157.131 98.5659 154.124C98.923 154.174 99.2831 154.2 99.6438 154.2C101.167 154.202 102.659 153.758 103.939 152.923C105.068 153.969 106.103 155.113 107.032 156.344Z"
      fill="#CFE3F1"
    />
    <path
      d="M93.6412 142.919V148.676H92.1254C91.8728 147.88 91.7449 147.049 91.7465 146.214C91.7435 145.077 91.9837 143.954 92.4505 142.919H93.6412Z"
      fill="#1072BA"
    />
    <path
      d="M136.708 197.441C152.301 193.381 163.869 185.541 163.137 179.666H163.263C163.263 179.666 163.768 181.065 164.457 183.331C165.713 187.379 166.765 191.488 167.608 195.644C167.891 197.053 168.141 198.488 168.343 199.908C168.58 201.556 168.752 203.19 168.848 204.763C168.985 206.806 168.898 208.858 168.59 210.883C168.596 210.956 168.584 211.029 168.555 211.097C168.333 212.297 168.05 213.441 167.765 214.519C164.228 217.579 152.607 219.87 138.864 219.87C125.365 219.87 113.938 217.689 110.163 214.687C109.597 213.181 109.08 211.627 108.616 210.126C107.09 205.104 105.892 199.987 105.028 194.808H105.069C107.27 200.285 121.136 201.495 136.708 197.441Z"
      fill="white"
    />
    <path
      d="M185.594 182.994C187.086 193.912 168.873 204.754 168.873 204.754H168.823C168.73 203.129 168.562 201.508 168.317 199.899L168.712 199.843C168.712 199.843 181.279 191.744 181.247 184.013C181.247 178.141 178.047 177.344 175.405 177.65C174.322 177.799 173.26 178.071 172.238 178.462C169.646 179.818 167.173 181.395 164.846 183.174L164.432 183.312C163.733 181.046 163.238 179.647 163.238 179.647C165.962 177.682 168.865 175.982 171.908 174.571C174.074 173.814 181.572 172.058 184.557 179.059C185.078 180.317 185.427 181.641 185.594 182.994Z"
      fill="white"
    />
    <path
      d="M174.763 150.502C179.037 150.859 189.904 156.333 192.701 165.632C196.622 178.67 195.145 196.501 202.755 207.904C203.73 209.387 204.846 210.771 206.088 212.035L206.158 211.964C204.383 197.375 211.369 190.338 211.369 190.338C210.707 187.127 210.703 183.814 211.358 180.601C212.012 177.389 213.311 174.346 215.174 171.659C214.611 165.364 216.415 159.087 220.227 154.072H277.363C278.375 155.39 279.249 156.81 279.969 158.311C281.243 160.861 282.077 163.612 282.438 166.445C282.657 168.183 282.657 169.941 282.438 171.679C284.297 174.364 285.593 177.404 286.246 180.613C286.9 183.821 286.897 187.131 286.237 190.338C286.237 190.338 293.208 197.375 291.437 211.964C291.437 211.964 297.902 221.156 296.127 231.541C296.127 231.541 290.194 241.755 248.801 241.755C212.033 241.755 201.475 231.541 201.475 231.541C200.931 228.09 201.132 224.561 202.066 221.197C199.675 218.877 197.533 216.309 195.676 213.536C188.097 202.135 191.063 183.277 187.142 170.244C183.221 157.212 165.584 153.092 165.584 153.092C169.18 153.556 174.787 154.112 175.996 153.418C177.512 152.514 176.976 150.819 174.756 150.543L174.763 150.502Z"
      fill="#CFE3F1"
    />
    <path
      d="M98.5878 154.138C98.2573 154.092 97.9299 154.025 97.6075 153.939C98.421 151.452 99.1233 149.699 99.1553 149.658C99.2837 149.346 99.3506 149.012 99.3524 148.674H100.269C100.268 149.085 100.367 149.49 100.555 149.854C100.743 150.219 101.016 150.532 101.35 150.767C102.266 151.432 103.138 152.157 103.96 152.938C102.681 153.773 101.189 154.216 99.6656 154.214C99.305 154.214 98.9448 154.189 98.5878 154.138Z"
      fill="#1072BA"
    />
    <path
      d="M263.645 137.139H233.953C236.479 133.518 248.715 133.386 248.715 133.386C248.715 133.386 261.138 133.518 263.645 137.139Z"
      fill="white"
    />
    <path
      d="M50.9482 142.919H87.792C87.7314 144.354 87.6859 145.503 87.6657 146.214C87.6657 146.76 87.6354 147.608 87.6303 148.676H50.9146V142.919H50.9482Z"
      fill="#1072BA"
    />
    <path
      d="M96.7722 175.1C98.007 179.624 98.5444 184.312 98.3654 189.001C97.4492 197.65 87.605 199.816 87.1907 199.903C87.0244 199.938 86.8552 199.956 86.6854 199.959C86.0527 199.969 85.4395 199.738 84.9669 199.314C84.4943 198.889 84.1969 198.301 84.1334 197.665C84.0699 197.03 84.2449 196.393 84.6239 195.882C85.0029 195.37 85.5583 195.021 86.1802 194.903C86.2357 194.903 92.8328 193.373 93.3583 188.458C93.4527 184.32 92.9419 180.191 91.8425 176.203C91.0102 172.866 90.4737 169.46 90.2391 166.027C90.0825 161.097 91.9688 154.746 93.2707 150.962C94.3363 152.43 95.8661 153.488 97.6075 153.961C96.2184 157.78 95.433 161.795 95.2799 165.861C95.5163 168.978 96.0155 172.069 96.7722 175.1Z"
      fill="#1072BA"
    />
    <path
      d="M169.576 61.4617C169.576 73.0791 174.148 84.2207 182.286 92.4355C190.425 100.65 201.463 105.265 212.973 105.265C224.482 105.265 235.52 100.65 243.659 92.4355C251.797 84.2207 256.37 73.0791 256.37 61.4617C256.37 55.7093 255.247 50.0132 253.066 44.6987C250.885 39.3842 247.689 34.5554 243.659 30.4878C239.629 26.4203 234.845 23.1937 229.58 20.9924C224.315 18.791 218.672 17.658 212.973 17.658C207.274 17.658 201.63 18.791 196.365 20.9924C191.1 23.1937 186.316 26.4203 182.286 30.4878C178.256 34.5554 175.06 39.3842 172.879 44.6987C170.698 50.0132 169.576 55.7093 169.576 61.4617Z"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M249.358 61.4572C249.361 68.7226 247.228 75.8256 243.231 81.8676C239.234 87.9097 233.551 92.6196 226.901 95.4015C220.252 98.1834 212.935 98.9124 205.875 97.4963C198.815 96.0802 192.329 92.5826 187.239 87.4459C182.149 82.3092 178.682 75.7641 177.277 68.6384C175.872 61.5128 176.592 54.1266 179.346 47.4141C182.1 40.7016 186.765 34.9643 192.75 30.9278C198.735 26.8914 205.771 24.7371 212.969 24.7374H212.979C222.628 24.7374 231.881 28.6061 238.703 35.4924C245.525 42.3787 249.358 51.7185 249.358 61.4572Z"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M242.943 143.359V146.876"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M248.715 143.359H255.452C257.279 143.277 259.038 142.639 260.5 141.529C261.961 140.419 263.055 138.889 263.639 137.139H233.946C234.529 138.888 235.623 140.419 237.084 141.529C238.545 142.639 240.305 143.277 242.131 143.359H248.708"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M254.655 143.359V146.876"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M263.645 137.139C261.119 133.518 248.715 133.386 248.715 133.386C248.715 133.386 236.467 133.518 233.953 137.139"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M277.37 154.077C277.286 153.675 277.18 153.278 277.052 152.887C276.689 151.759 276.039 150.748 275.167 149.953C274.295 149.158 273.232 148.607 272.083 148.357C271.423 148.169 270.746 148.044 270.062 147.984C266.436 147.551 259.62 147.418 254.664 147.383H242.948C236.831 147.423 227.726 147.617 225.52 148.357C224.167 148.652 222.936 149.357 221.992 150.379C221.048 151.401 220.436 152.689 220.238 154.072L277.37 154.077Z"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M206.158 211.968C204.383 197.379 211.369 190.343 211.369 190.343C210.707 187.132 210.703 183.818 211.358 180.606C212.012 177.393 213.311 174.35 215.174 171.663C214.611 165.369 216.415 159.091 220.226 154.077"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M279.976 158.32C281.249 160.869 282.084 163.618 282.445 166.449C282.664 168.187 282.664 169.946 282.445 171.684C284.304 174.369 285.6 177.409 286.253 180.617C286.906 183.826 286.903 187.135 286.244 190.343C286.244 190.343 293.215 197.379 291.443 211.968C291.443 211.968 297.909 221.16 296.134 231.545C296.134 231.545 290.2 241.759 248.808 241.759C212.04 241.759 201.481 231.545 201.481 231.545C200.937 228.095 201.139 224.566 202.072 221.201"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M277.37 154.077C278.382 155.394 279.255 156.814 279.976 158.315"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M216.57 191.558C216.57 191.558 226.967 195.341 245.781 195.361C270.37 195.387 280.491 191.558 280.491 191.558"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M221.816 172.066C229.925 173.458 238.139 174.12 246.364 174.043C265.744 174.043 274.734 172.066 274.734 172.066"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M214.547 212.494C224.621 215.841 235.177 217.472 245.781 217.32C270.371 217.32 282.008 212.494 282.008 212.494"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M165.586 153.086C165.586 153.086 183.216 157.207 187.144 170.239C191.071 183.271 188.07 202.127 195.677 213.531C197.535 216.304 199.677 218.871 202.067 221.191C205.386 224.509 209.228 227.247 213.436 229.295"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M174.763 150.502C179.037 150.859 189.904 156.333 192.701 165.632C196.622 178.67 195.145 196.501 202.755 207.904C203.73 209.387 204.846 210.771 206.088 212.035C208.554 214.724 211.835 216.508 215.416 217.106"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M270.054 147.987C270.309 147.015 270.859 146.148 271.626 145.508C272.394 144.867 273.341 144.486 274.335 144.417C277.417 144.419 280.469 145.023 283.324 146.195"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M279.976 158.32C280.041 158.08 281.741 151.896 285.136 153.851C286.426 154.592 286.871 156.666 286.891 158.677C286.936 163.032 288.07 166.291 290.397 167.594C291.844 168.399 294.608 168.707 295.502 171.228C296.397 173.749 295.4 178.708 297.523 181.136C299.647 183.563 307.642 182.264 304.597 193.901"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M282.45 166.449C283.419 167.98 284.767 169.229 286.36 170.075C288.718 171.146 285.48 174.043 288.338 177.932C290.766 181.242 294.217 179.853 294.349 183.423C294.48 186.993 291.024 191.706 294.222 193.125C296.341 194.053 301.451 194.305 304.622 194.223C305.508 194.253 306.393 194.16 307.253 193.946C309.274 192.799 309.859 190.004 308.659 184.55C307.46 179.097 303.145 178.99 301.08 176.56C299.016 174.131 299.977 169.183 299.059 166.655C298.141 164.127 295.459 163.729 293.955 163.018C292.451 162.308 291.248 160.394 290.45 154.104C289.746 148.558 286.002 146.056 283.366 146.234C283.02 146.255 282.68 146.327 282.355 146.449C279.755 147.469 278.049 150.699 277.402 152.812"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M174.758 150.536C174.326 150.487 173.89 150.487 173.458 150.536C171.762 150.706 168.156 151.436 165.542 151.987C165.413 152.012 165.297 152.083 165.215 152.188C165.134 152.292 165.092 152.423 165.097 152.555C165.103 152.688 165.155 152.815 165.245 152.912C165.335 153.009 165.456 153.07 165.587 153.085C169.183 153.549 174.79 154.105 175.999 153.411C177.505 152.503 176.968 150.808 174.758 150.536Z"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M201.469 231.546C208.264 241.759 240.474 251.691 280.491 244.889C321.379 237.934 296.134 231.546 296.134 231.546"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M214.288 57.0993C214.447 57.1455 214.603 57.2023 214.755 57.2693"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M217.03 59.417C217.432 60.2201 217.589 61.1255 217.481 62.0186C217.373 62.9117 217.005 63.7526 216.424 64.4347C215.843 65.1168 215.074 65.6097 214.215 65.8509C213.357 66.0921 212.446 66.0708 211.599 65.7898C210.753 65.5088 210.007 64.9806 209.458 64.272C208.909 63.5635 208.58 62.7064 208.513 61.8092C208.446 60.912 208.644 60.0149 209.083 59.2314C209.521 58.448 210.179 57.8133 210.975 57.4076C211.042 57.3719 211.112 57.3396 211.182 57.3073"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M213.003 25.385V29.4701"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M213.003 93.2986V97.3837"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M177.261 61.4621H181.315"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M245.053 61.4621H249.106"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M187.834 36.0563L190.699 38.9463"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M235.415 84.0773L238.278 86.9689"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M187.834 87.0764L190.699 84.1847"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M235.77 38.6917L238.633 35.8"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M198.509 28.5659L200.159 32.2991"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M225.924 90.5889L227.578 94.3221"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M180.434 76.2134L184.132 74.5474"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M242.342 48.3327L246.039 46.6616"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M228.924 29.0746L227.118 32.7363"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M198.93 89.8743L197.123 93.5343"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M180.995 45.2885L184.622 47.1126"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M241.678 75.7894L245.306 77.6135"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M168.737 213.282C168.513 213.769 168.18 214.197 167.765 214.533C164.228 217.593 152.607 219.884 138.864 219.884C125.365 219.884 113.938 217.703 110.163 214.701C109.792 214.466 109.479 214.148 109.248 213.772C109.017 213.396 108.875 212.971 108.833 212.53"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M164.872 221.824C159.676 224.034 149.973 225.501 138.864 225.501C127.755 225.501 118.045 224.025 112.855 221.824"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M120.033 253.698C117.472 252.081 115.315 249.89 113.731 247.294C112.898 245.975 112.156 244.6 111.509 243.178C110.87 241.748 110.371 240.259 110.017 238.731C108.655 231.872 108.145 224.868 108.501 217.881C108.552 216.094 108.64 214.308 108.764 212.524C108.814 211.805 108.85 211.406 108.85 211.406"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M168.873 210.941C168.873 210.941 170.923 233.15 166.293 243.178C165.563 244.774 164.709 246.309 163.738 247.768C159.059 254.738 152.215 257.567 138.95 257.358H138.864C130.288 257.491 124.395 256.338 120.038 253.671"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M159.726 175.58C160.504 175.894 161.204 176.377 161.776 176.994C162.349 177.611 162.781 178.347 163.041 179.15C163.085 179.318 163.117 179.488 163.137 179.66C163.869 185.537 152.301 193.376 136.708 197.435C121.116 201.495 107.27 200.279 105.069 194.8C104.995 194.636 104.936 194.465 104.892 194.29C103.881 190.38 108.701 185.466 116.715 181.381C121.349 179.07 126.213 177.263 131.224 175.988C143.295 172.838 154.339 172.859 159.726 175.58Z"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M109.075 194.719C107.78 189.648 117.874 182.632 131.618 179.057C145.363 175.482 157.555 176.687 158.857 181.763"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M161.791 190.051C154.535 195.419 146.31 199.304 137.579 201.49C128.645 203.96 119.296 204.494 110.143 203.058"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M110.189 214.701C109.623 213.195 109.106 211.641 108.641 210.14C107.115 205.118 105.917 200.001 105.053 194.821"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M163.263 179.661C163.263 179.661 163.768 181.06 164.457 183.326C165.713 187.374 166.765 191.483 167.608 195.639C167.891 197.048 168.141 198.483 168.343 199.903C168.58 201.552 168.752 203.185 168.848 204.758C168.985 206.801 168.899 208.853 168.59 210.878C168.596 210.951 168.584 211.024 168.555 211.092C168.333 212.292 168.05 213.436 167.765 214.514"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M163.263 179.66C165.975 177.683 168.871 175.975 171.908 174.56C174.074 173.804 181.572 172.047 184.557 179.048C185.079 180.308 185.428 181.635 185.594 182.99C187.086 193.908 168.873 204.75 168.873 204.75"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M164.872 183.188C167.199 181.408 169.671 179.832 172.264 178.476C173.293 178.091 174.362 177.825 175.45 177.683C178.096 177.377 181.274 178.193 181.294 184.046C181.325 191.768 168.757 199.877 168.757 199.877"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M159.721 175.586C162.378 173.904 165.301 172.696 168.363 172.016C173.133 171.203 182.711 170.923 184.552 179.047"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M175.45 177.683C177.976 178.608 178.283 180.743 177.934 183.914C177.429 188.616 171.145 193.218 167.629 195.659"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M120.038 253.698C120.038 253.851 120.216 256.955 127.824 259.648C134.163 261.885 161.811 264.601 179.548 256.89C194.254 250.503 163.753 247.802 163.753 247.802"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M108.535 118.917L126.165 85.9368C126.38 85.5243 126.486 85.0626 126.473 84.5966C126.46 84.1305 126.327 83.6759 126.088 83.2767C125.85 82.8776 125.513 82.5474 125.11 82.3183C124.708 82.0892 124.254 81.9689 123.792 81.969H119.8C118.871 81.9689 117.969 82.2852 117.24 82.8666L115.021 84.6295C113.768 85.6276 112.226 86.1845 110.63 86.2152C109.034 86.2459 107.472 85.7487 106.182 84.7995L103.405 82.7595C102.699 82.2425 101.848 81.964 100.976 81.9639H33.0737C32.6117 81.9647 32.1577 82.0859 31.7557 82.3157C31.3537 82.5456 31.0173 82.8763 30.7791 83.2759C30.5409 83.6755 30.409 84.1305 30.3962 84.5966C30.3833 85.0628 30.49 85.5244 30.7057 85.9368L48.3361 118.903"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M50.9112 142.919V138.297L42.3975 126.353C41.9002 125.65 41.6041 124.823 41.5418 123.962C41.4795 123.101 41.6533 122.239 42.0442 121.471C42.4351 120.703 43.028 120.058 43.7579 119.608C44.4878 119.157 45.3264 118.918 46.1819 118.917H80.6392C81.6736 118.917 82.6979 119.123 83.6535 119.523C84.6091 119.923 85.4773 120.509 86.2086 121.247C86.9399 121.986 87.52 122.862 87.9156 123.827C88.3113 124.792 88.5148 125.826 88.5146 126.87V127.263C88.2602 132.429 87.9571 138.843 87.7853 142.928"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M87.6303 148.674C87.5949 153.208 87.6303 161.699 87.6303 168.042C87.6395 170.23 86.7957 172.333 85.2812 173.898C83.7667 175.463 81.703 176.364 79.536 176.406C78.6197 176.406 77.7557 176.436 77.0366 176.436C66.6098 176.303 56.2071 175.39 45.9141 173.705L45.6901 173.669C44.8231 173.535 44.0102 173.16 43.3429 172.585C42.6755 172.011 42.1801 171.26 41.9124 170.417C41.6406 169.571 41.5698 168.673 41.7059 167.795C41.842 166.916 42.181 166.083 42.6955 165.361L50.9061 153.815V148.674"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M105.028 140.309L114.46 126.353C114.959 125.653 115.257 124.827 115.322 123.966C115.387 123.105 115.216 122.244 114.827 121.475C114.439 120.706 113.849 120.059 113.121 119.607C112.393 119.154 111.556 118.912 110.701 118.907H107.043C106.063 118.906 105.105 119.202 104.294 119.756C103.484 120.311 102.857 121.099 102.495 122.018C100.855 127.265 99.9129 132.709 99.6926 138.206"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M102.67 175.171C101.53 175.008 100.485 174.441 99.7211 173.571C98.9574 172.701 98.5252 171.585 98.5018 170.423C98.3957 165.051 98.2997 157.146 98.5877 154.139"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M113.892 164.975L114.17 165.362C114.683 166.086 115.02 166.922 115.155 167.801C115.291 168.681 115.22 169.58 114.948 170.427C114.676 171.264 114.182 172.011 113.52 172.586C112.855 173.16 112.044 173.536 111.179 173.668L110.931 173.709C110.379 173.806 109.848 173.959 109.175 174.139"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M113.731 247.295C102.301 250.835 90.3921 252.544 78.4379 252.361C55.3996 252.361 42.5945 247.224 40.0143 246.146C39.3046 245.852 38.7389 245.286 38.4405 244.572C38.142 243.859 38.1351 243.055 38.4211 242.336L39.4316 239.744L36.555 237.066C27.2918 230.673 25.931 220.077 26.5625 210.936C27.6404 194.815 45.8434 174.119 45.8434 174.119"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M111.009 174.11C111.009 174.11 113.512 176.954 116.715 181.356"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M33.0029 205.617C36.7722 192.391 49.2572 178.201 49.2572 178.201"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M109.683 238.824C105.518 240.354 95.8459 242.664 78.4581 242.664C67.9327 242.691 57.457 241.207 47.3457 238.256C44.9708 237.536 42.788 236.283 40.9609 234.591C33.7407 229.601 31.8948 221.773 31.8948 214.431V214.031C31.8948 213.067 31.9402 212.117 32.0059 211.182"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M44.3798 122.193H78.4328"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M44.3798 169.779C47.1487 170.405 49.954 170.853 52.7789 171.122C56.5179 171.394 78.4328 172.652 78.4328 172.652"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M55.2278 138.206H75.4585"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M61.4038 153.464H77.0366"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M104.301 138.206H105.813"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M108.424 217.882C100.365 218.613 89.9528 219.046 78.613 219.046C52.9995 219.046 32.2366 216.804 32.2366 214.031C32.2366 211.259 52.981 209.016 78.6147 209.016C90.1599 209.016 100.211 209.47 108.328 210.227"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M40.0093 246.145C42.0165 248.916 44.8888 250.926 48.1642 251.85C64.4303 256.889 106.743 258.176 120.033 253.698"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path d="M294.849 203.875H322" stroke="#1072BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.404" />
    <path
      d="M176.851 203.875H187.405"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path d="M2 203.875H25.0703" stroke="#1072BA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.404" />
    <path
      d="M61.4392 79.8167C60.6861 78.4593 60.289 76.9303 60.2855 75.3746C59.7196 56.3348 101.31 77.0746 101.7 61.4551C102.091 45.8356 67.8038 67.2147 66.4632 51.2722C65.1226 35.3297 98.7798 51.0937 98.699 38.9405C98.6181 26.7872 71.0678 40.2885 70.4042 30.4218C69.7407 20.5551 95.1621 28.3393 95.1621 20.1743C95.1621 12.0092 82.1196 17.4373 80.5314 10.4707C78.7899 2.85817 87.6741 0.677081 90.9061 2.73067"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
    <path
      d="M72.9289 112.649C69.2236 94.5918 101.7 110.519 101.7 93.5344C101.7 81.1619 80.0261 87.2852 68.0363 84.164"
      stroke="#1072BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.404"
    />
  </svg>
);
